<template>
  <div class="support-page">

    <!-- Hero -->
    <div class="sp-hero">
      <div class="sp-hero-bg"></div>
      <div class="container sp-hero-content">
        <h1>{{ $t('supportTitle') }}</h1>
        <p>{{ $t('supportSubtitle') }}</p>
      </div>
    </div>

    <!-- Contact Cards -->
    <section class="sp-section">
      <div class="container">
        <h2 class="sp-section-title">{{ $t('connectwithus') }}</h2>
        <p class="sp-section-sub">{{ $t('workingHours') }}</p>
        <div class="sp-grid">
          <div class="sp-card">
            <div class="sp-ic">
              <i class="fas fa-phone-alt"></i>
            </div>
            <h3>{{ $t('phone') }}</h3>
            <div class="sp-val">
              <a href="tel:+998712020897">+998 (71) 202 08 97</a>
            </div>
          </div>

          <div class="sp-card">
            <div class="sp-ic">
              <i class="fas fa-envelope"></i>
            </div>
            <h3>Email</h3>
            <div class="sp-val">
              <a href="mailto:info@biznesombudsman.uz">info@biznesombudsman.uz</a>
            </div>
            <small>{{ $t('replyTime') }}</small>
          </div>

          <div class="sp-card">
            <div class="sp-ic">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <h3>{{ $t('address') }}</h3>
            <div class="sp-val sp-val-sm">{{ $t('addressus') }}</div>
          </div>

          <div class="sp-card">
            <div class="sp-ic">
              <i class="fab fa-telegram-plane"></i>
            </div>
            <h3>Telegram</h3>
            <div class="sp-val">
              <a href="https://t.me/biznes_ombudsman" target="_blank" rel="noopener">
                @biznes_ombudsman
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Map -->
    <section class="sp-section sp-map-section">
      <div class="container">
        <h2 class="sp-section-title">{{ $t('mapLocation') }}</h2>
        <p class="sp-section-sub">Toshkent shahri, Nukus ko'chasi, 73A</p>
        <div class="sp-map-wrap">
          <iframe
            src="https://yandex.uz/map-widget/v1/?ll=69.274337%2C41.288200&z=18&pt=69.274222%2C41.288123,pm2rdl~Biznes+ombudsman&lang=uz_UZ"
            width="100%"
            height="420"
            frameborder="0"
            allowfullscreen
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </section>

    <!-- Contact Form -->
    <section class="sp-section sp-form-section">
      <div class="container">
        <div class="sp-form-card">
          <h2>{{ $t('writeToUs') }}</h2>
          <p class="sp-form-sub">{{ $t('writeToUsSub') }}</p>
          <div class="sp-form-row">
            <div class="sp-field">
              <label>{{ $t('yourName') }}</label>
              <input type="text" v-model="form.fullName" :placeholder="$t('yourName')" />
            </div>
            <div class="sp-field">
              <label>{{ $t('phone') }}</label>
              <input type="text" v-model="form.phoneNumber" placeholder="+998 __ ___ __ __" />
            </div>
          </div>
          <div class="sp-field">
            <label>{{ $t('subject') }}</label>
            <select v-model="form.subjectId">
              <option :value="1">{{ $t('subjectTech') }}</option>
              <option :value="2">{{ $t('subjectAccount') }}</option>
              <option :value="3">{{ $t('subjectComplaint') }}</option>
              <option :value="4">{{ $t('subjectOther') }}</option>
            </select>
          </div>
          <div class="sp-field">
            <label>{{ $t('message') }}</label>
            <textarea v-model="form.message" rows="4"></textarea>
          </div>
          <button class="sp-btn" :disabled="sending" @click="submitForm">
            {{ sending ? '...' : $t('send') }}
          </button>
          <div v-if="formSent" class="sp-form-ok">
            ✓ {{ $t('formSuccess') }}
          </div>
          <div v-if="formError" class="sp-form-err">
            ✗ {{ formError }}
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import ContactMessageService from '@/services/contactmessage.service'

export default {
  data() {
    return {
      formSent: false,
      formError: '',
      sending: false,
      form: {
        fullName: '',
        phoneNumber: '',
        subjectId: 1,
        message: '',
        contractorId: 0
      }
    }
  },
  methods: {
    async submitForm() {
      this.formError = ''
      if (!this.form.fullName || !this.form.phoneNumber || !this.form.message) {
        return
      }
      this.sending = true
      try {
        await ContactMessageService.Create(this.form)
        this.formSent = true
        this.form = { fullName: '', phoneNumber: '', subjectId: 1, message: '', contractorId: 0 }
      } catch (e) {
        this.formError = e.response?.data || this.$t('errorOccurred') || 'Xatolik yuz berdi'
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style scoped>
.support-page {
  background: #f4f7fb;
  min-height: 100vh;
}

/* Hero */
.sp-hero {
  background: linear-gradient(135deg, #0b2447 0%, #19376d 100%);
  color: #fff;
  padding: 64px 0 56px;
  position: relative;
  overflow: hidden;
}
.sp-hero-bg {
  position: absolute;
  right: -80px;
  top: -80px;
  width: 340px;
  height: 340px;
  background: radial-gradient(circle, rgba(165,215,232,.25), transparent 70%);
  border-radius: 50%;
}
.sp-hero-content {
  position: relative;
}
.sp-hero h1 {
  font-size: 38px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin-bottom: 12px;
  font-family: 'Montserrat-extrabold', sans-serif;
}
.sp-hero p {
  font-size: 17px;
  color: #a5d7e8;
  max-width: 560px;
}

/* Sections */
.sp-section {
  padding: 56px 0;
}
.sp-map-section {
  background: #fff;
  border-top: 1px solid #e3e9f2;
  border-bottom: 1px solid #e3e9f2;
}
.sp-form-section {
  background: #fff;
}
.sp-section-title {
  font-size: 26px;
  font-weight: 800;
  color: #0b2447;
  margin-bottom: 6px;
  font-family: 'Montserrat-bold', sans-serif;
}
.sp-section-sub {
  color: #5b6478;
  margin-bottom: 32px;
}

/* Cards grid */
.sp-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
}
.sp-card {
  background: #fff;
  border: 1px solid #e3e9f2;
  border-radius: 14px;
  padding: 26px;
  box-shadow: 0 4px 20px rgba(11,36,71,.06);
  transition: transform .2s, box-shadow .2s;
}
.sp-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 40px rgba(11,36,71,.10);
}
.sp-ic {
  width: 46px;
  height: 46px;
  border-radius: 11px;
  background: #eef3fb;
  color: #19376d;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  font-size: 20px;
}
.sp-card h3 {
  font-size: 14px;
  color: #5b6478;
  font-weight: 600;
  margin-bottom: 4px;
}
.sp-val {
  font-size: 17px;
  font-weight: 700;
  color: #0b2447;
  word-break: break-word;
}
.sp-val a {
  color: #0b2447;
  text-decoration: none;
}
.sp-val a:hover {
  color: #3F75FE;
}
.sp-val-sm {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
}
.sp-card small {
  display: block;
  color: #5b6478;
  margin-top: 6px;
  font-size: 13px;
}

/* Map */
.sp-map-wrap {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #e3e9f2;
  box-shadow: 0 4px 20px rgba(11,36,71,.06);
  line-height: 0;
}

/* Form */
.sp-form-card {
  background: linear-gradient(135deg, #0b2447, #19376d);
  border-radius: 18px;
  padding: 42px;
  color: #fff;
  box-shadow: 0 12px 40px rgba(11,36,71,.10);
}
.sp-form-card h2 {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 6px;
  font-family: 'Montserrat-bold', sans-serif;
}
.sp-form-sub {
  color: #a5d7e8;
  margin-bottom: 28px;
}
.sp-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.sp-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
}
.sp-field label {
  font-size: 13px;
  font-weight: 600;
  color: #a5d7e8;
}
.sp-field input,
.sp-field textarea,
.sp-field select {
  padding: 13px 15px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,.2);
  background: rgba(255,255,255,.08);
  color: #fff;
  font-size: 15px;
  font-family: inherit;
  outline: none;
  transition: border-color .18s, background .18s;
}
.sp-field input::placeholder,
.sp-field textarea::placeholder {
  color: rgba(255,255,255,.4);
}
.sp-field input:focus,
.sp-field textarea:focus,
.sp-field select:focus {
  border-color: #a5d7e8;
  background: rgba(255,255,255,.14);
}
.sp-field select option {
  color: #000;
}
.sp-btn {
  background: #fff;
  color: #0b2447;
  border: none;
  padding: 15px 32px;
  border-radius: 11px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background .2s;
}
.sp-btn:hover {
  background: #a5d7e8;
}
.sp-form-ok {
  background: rgba(22,163,74,.15);
  border: 1px solid #16a34a;
  color: #bbf7d0;
  padding: 14px 18px;
  border-radius: 10px;
  margin-top: 18px;
  font-size: 14px;
}
.sp-form-err {
  background: rgba(239,85,121,.15);
  border: 1px solid #EF5579;
  color: #ffc0cc;
  padding: 14px 18px;
  border-radius: 10px;
  margin-top: 18px;
  font-size: 14px;
}
.sp-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 640px) {
  .sp-hero h1 { font-size: 28px; }
  .sp-form-row { grid-template-columns: 1fr; }
  .sp-form-card { padding: 24px; }
}
</style>
